import React from 'react';

import { Route } from 'react-router';

import Webview from './Webview';

export default <Route path="*" component={Webview} />;
